// there is no fr-CA job board

const getJobsLocale = (locale) => (locale === 'fr-CA' ? 'en-CA' : locale);

export default getJobsLocale;
